import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import { LoaderService } from '../shared/loader/loader-service.service';
// import { SessionHandlerService } from './sessionHandler.service';
import { AlertService } from '../shared/alert.service';
import { RequestPayLoadFormat } from './common-service-layer.service';
import { SessionhandlerService } from './sessionhandler.service';
import { Config } from '../config/config';
import { SharedService } from '../shared/shared.service';

@Injectable({
    providedIn: 'root'
})
export class HttpLayerService {
    private monitoring = {
        pendingRequestsNumber: 0
    };
    public currentDomain: any = window.location.hostname;
    public httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(
        private http: HttpClient,
        private router: Router,
        private loaderService: LoaderService,
        private sessionService: SessionhandlerService,
        public sharedService: SharedService
    ) {
    }

    public get(url, request?: RequestPayLoadFormat): Observable<any> {
        try {
            if (request.loader) {
                this.showLoader();
                this.monitoring.pendingRequestsNumber++;
            }
            let headerJson;
            // const token = this.sessionService.api.local.get('userName');
            const token = this.sessionService.api.session.get('userName');
            if (!token && !request.disableTokenValidation) {
                this.logOut();
            }
            headerJson = {
                'Content-Type': 'text/plain',
                authorization: `bearer ${token}`
            };

            const headersConfig = new HttpHeaders(headerJson);
            const requestOptions: any = { headersConfig, responseType: 'text' };
            return this.handleResponse(this.http.get(url, requestOptions)).map((res: any) => {
                let response = res;
                try {
                    response = atob(res);
                } catch (error) {
                } finally {
                    response = JSON.parse(response);
                }
                return response;
            }).finally(() => {
                if (request.loader) {
                    this.monitoring.pendingRequestsNumber--;
                    this.hideLoader();
                }
            });
        } catch (error) {
            Config.logger(error);
        }
    }

    public post(url, request: RequestPayLoadFormat): Observable<any> {
        try {
            request = JSON.parse(JSON.stringify(request));
            if (request.loader) {
                this.showLoader();
                this.monitoring.pendingRequestsNumber++;
            }
            let headerJson;
            // const token = this.sessionService.api.local.get('userName');
            const token = this.sessionService.api.session.get('userName');
            if (!token) {
                this.logOut();
            }
            headerJson = request.options ? request.options : {
                'Content-Type': 'application/json',
                authorization: `bearer ${token}`
            };
            const headersConfig = new HttpHeaders(headerJson);
            const requestOptions = { headers: headersConfig };
            this.monitoring.pendingRequestsNumber++;
            const userDetails = this.getUserDetails();
            request.payLoad = Object.assign(userDetails, request.payLoad);
            const body = JSON.stringify(request.payLoad);
            return this.handleResponse(this.http.post(url, body, requestOptions)).finally(() => {
                if (request.loader) {
                    this.monitoring.pendingRequestsNumber--;
                    this.hideLoader();
                }
            });
        } catch (error) {
            Config.logger(error);
        }
    }

    public postText(url, request: RequestPayLoadFormat): Observable<any> {
        try {
            request = JSON.parse(JSON.stringify(request));
            if (request.loader) {
                this.showLoader();
                this.monitoring.pendingRequestsNumber++;
            }
            let headerJson;
            // const token = this.sessionService.api.local.get('userName');
            const token = this.sessionService.api.session.get('userName');
            if (!token && !request.disableTokenValidation) {
                this.logOut();
            }
            headerJson = request.options ? request.options : {
                'Content-Type': 'text/plain',
                authorization: `bearer ${token}`
            };

            const headersConfig = new HttpHeaders(headerJson);
            const requestOptions: any = { headersConfig, responseType: 'text' };
            const userDetails = this.getUserDetails();
            let data = JSON.parse(JSON.stringify(request.payLoad));
            data = Object.assign(userDetails, data);
            const body = window.btoa(JSON.stringify(data));
            return this.handleResponse(
                this.http.post(url, body, requestOptions).map((res: any) => {
                    let response = res;
                    response = window.atob(res);
                    response = JSON.parse(response);
                    return response;
                })
            ).finally(() => {
                if (request.loader) {
                    this.monitoring.pendingRequestsNumber--;
                    this.hideLoader();
                }
            });
        } catch (error) {
            Config.logger(error);
        }
    }
    getUserDetails() {
        const obj: any = {};
        try {
            // obj.userName = this.sessionService.api.local.get('userName');
            // obj.userRole = this.sessionService.api.local.get('userRole');
            // obj.station_list = this.sessionService.api.local.get('station_list');
            // obj.siteId = this.sessionService.api.local.get('siteId');
            // obj.siteName = this.sessionService.api.local.get('siteName');
            obj.userName = this.sessionService.api.session.get('userName');
            obj.userRole = this.sessionService.api.session.get('userRole');
            obj.station_list = this.sessionService.api.session.get('station_list');
            obj.siteId = this.sessionService.api.session.get('siteId');
            obj.siteName = this.sessionService.api.session.get('siteName');
        } catch (error) {
            Config.logger(error);
        }
        return obj;
    }
    public postFile(url, request: RequestPayLoadFormat): Observable<any> {
        /**
         * With header 'Content-Type': 'multipart/form-data' file was not getting in BE
         */
        const headerOptions = {
            headers: new HttpHeaders({
                // Accept: 'application/json'
                Accept: 'multipart/form-data'
            })
        };
        try {
            if (request.loader) {
                this.showLoader();
                this.monitoring.pendingRequestsNumber++;
            }
            const userDetails = this.getUserDetails();
            const data = Object.assign(userDetails, request.payLoad);
            request.formData.append('jsonEnd', JSON.stringify(data));
            // return this.handleResponse(this.http.post(url, request.formData, headerOptions)).finally(() => {
            //     if (request.loader) {
            //         this.monitoring.pendingRequestsNumber--;
            //         this.hideLoader();
            //     }
            // });
            let headerJson;
            headerJson = request.options ? request.options : {
                'Content-Type': 'text/plain',
                // authorization: `bearer ${token}`
            };
            const headersConfig = new HttpHeaders(headerJson);
            const requestOptions: any = { headersConfig, responseType: 'text' };
            return this.handleResponse(
                this.http.post(url, request.formData, requestOptions).map((res: any) => {
                    let response = res;
                    response = window.atob(res);
                    response = JSON.parse(response);
                    return response;
                })
            ).finally(() => {
                if (request.loader) {
                    this.monitoring.pendingRequestsNumber--;
                    this.hideLoader();
                }
            });
        } catch (error) {
            Config.logger(error);
            throw 500;
        }
    }


    public handleResponse(observable: Observable<any>, loader?): Observable<any> {
        try {
            return observable.catch((err) => {
                if (err.status === 401) {
                    this.logOut();
                }
                // this.sharedService.httpError(err);
                return Observable.throw(err);
            }).finally(() => {
                if (loader) {
                    this.hideLoader();
                }
            });
        } catch (e) {
            console.log(e);
        }
    }
    public logOut() {
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['/login']);
    }
    public handleError(error: any) {
        const errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        return Observable.throw(errMsg);
    }
    private showLoader(): void {
        this.monitoring.pendingRequestsNumber++;
        this.loaderService.show();
    }

    private hideLoader(): void {
        this.monitoring.pendingRequestsNumber--;
        if (this.monitoring.pendingRequestsNumber <= 0) {
            this.loaderService.hide();
        }
    }
}
